import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import mainMap from '@/store/modules/mainMap.js'
import driveMap from '@/store/modules/driveMap.js'
import routeMap from '@/store/modules/routeMap.js'
import ui from '@/store/modules/ui.js'

const store = new Vuex.Store({
  modules: {
    mainMap: mainMap,
		driveMap: driveMap,
		routeMap: routeMap,
    ui: ui
  },
})

export default store
